<div class="language-switch-wrapper">
    <button class="locale-btn-mr-8" [ngClass]="[switchButtons.firstButton.buttonLocale.toLowerCase() == localeName.toLowerCase() ? 'select_locale_button' : 'locale_button']" (click)="onButtonClick(switchButtons.firstButton.buttonLocale)">
      <app-text [class]="'text-c300 h5-bold'">{{ switchButtons.firstButton.buttonText }}</app-text>
    </button>
    <button [ngClass]="[switchButtons.secondButton.buttonLocale.toLowerCase() == localeName.toLowerCase() ? 'select_locale_button' : 'locale_button']" (click)="onButtonClick(switchButtons.secondButton.buttonLocale)">
      <app-text [class]="'text-c300 h5-bold'">{{ switchButtons.secondButton.buttonText }}</app-text>
    </button>
</div>
